import type { FormStatus } from "../../types/forms";
import { statusLabels } from "../../shared/customerForms";

export default function FormStatusBadge({ status }: { status: FormStatus }) {
  const color =
    status === "rejected"
      ? "bg-red-100 text-red-800"
      : status === "cancelled"
        ? "bg-gray-100 text-gray-700"
        : ["credit_issued", "completed"].includes(status)
          ? "bg-green-100 text-green-800"
          : "bg-indigo-100 text-indigo-800";
  return (
    <span className={`inline-flex rounded-full px-3 py-1 text-xs font-semibold ${color}`}>
      {statusLabels[status] || status}
    </span>
  );
}
